import React from 'react'

import { Permissions } from '../constants/permissions'

import LoginPage from '../pages/login'
import PasswordRecoveryPage from '../pages/password-recovery'
import PasswordResetPage from '../pages/password-reset'
import HomePage from '../pages_v2/home'
import PersonnelPage from '../pages_v2/personnel'
import InviteAcceptPage from '../pages_v2/home/invite-accept'
import CompanyUiLabPage from '../pages_v2/home/company/ui-lab'
/*
import CasesListPage from '../pages/list-cases'
import OrdersListPage from '../pages/list-orders'
import MailsListPage from '../pages/list-mails'
import CardMail from '../pages/card-mail'
import EmployeeListPage from '../pages/list-employees'
import CardEmployeePage from '../pages/card-employee'
import FrozeCardPage from '../pages/card-measurement'
import EditCasePage from '../pages/card-case'
import CardClient from '../pages/card-client'
import CardMountingPage from '../pages/card-mounting'
import CardDeliveryPage from '../pages/card-delivery'
import CardManufacturePage from '../pages/card-manufacture'
import AuditCardPage from '../pages/card-audit'
import ComplaintCardPage from '../pages/card-complaint'
import PageListUsers from '../pages/list-users'
import PageCardUser from '../pages/card-user'
import PageListOrganizations from '../pages/list-organizations'
import PageCardOrganization from '../pages/card-organization'
import ReportsList from '../pages/list-reports'
import ReportCard from '../pages/card-report'
import ComplaintListPage from '../pages/list-complaint'
import TasksListOrderPage from '../pages/list-tasks-orders'
import { TasksListPage } from '../pages/list-tasks'
import FrozesListPage from '../pages/list-measurements'
import ManufactureListPage from '../pages/list-manufacture'
import MountingListPage from '../pages/list-mounting'
import PageListProfilesOrganizations from '../pages/list-profiles-organizations'
import PageCardProfileOrganization from '../pages/card-profile-organization'
import Migration from '../pages_v2/migration'
import DadataTest from '../pages_v2/dadata-test'
*/
import ListClients from '../pages/list-clients'
import TasksCalendar from '../pages_v2/tasks-calendar-page'
import DeliveryListPage from '../pages/list-delivery'
import ListCallLog from '../pages_v2/list-call-log'
import AuditListPage from '../pages/list-audit'
import ClaimsListPage from '../pages/list-claims'
import ClaimCardPage from '../pages/card-claim'
import ClaimRequestsListPage from '../pages/list-claim-requests'
import ClaimRequestCardPage from '../pages/card-claim-request'
import { AdminCollectionsListPage } from '../pages/list-admin-collections/admin-collections-list'
import AdminNewCollectionPage from '../pages/admin-new-collection'
import AdminEditCollectionPage from '../pages/admin-edit-collection'
import { AdminObjectsListPage } from '../pages/list-admin-objects'
import AdminNewObjectPage from '../pages/admin-new-object'
import AdminEditObjectPage from '../pages/admin-edit-object'
import AdminSchemasListPage from '../pages/list-admin-schemas'
import AdminNewSchemaPage from '../pages/admin-new-schema'
import AdminEditSchemaPage from '../pages/admin-edit-schema'
import { CalculatorPage } from '../pages/calculator'

import ReportMarketingCard from '../pages/card-report-marketing'
import ReportMarketingList from '../pages/list-report-marketing'
import HrListPage from '../pages/list-hr'
import HrCardPage from '../pages/card-hr/new'
import Tasks from '../pages_v2/tasks'
import { AdminListRoles, AdminEditRole } from '../pages_v2/admin/roles'
import NewClientCardPage from '../pages_v2/clients/card'
import NewListClients from '../pages_v2/clients/list'
import NewOrdersListPage from '../pages_v2/orders/list'
import CardOrder from '../pages_v2/orders/card'
import OrganizationsList from '../pages_v2/organizations/list'
import OrganizationCard from '../pages_v2/organizations/card'
import OfficesList from '../pages_v2/offices/list'
import OfficeCard from '../pages_v2/offices/card'
import UserCardPage from '../pages_v2/users/card'
import UsersListPage from '../pages_v2/users/list'
import Collections from '../pages_v2/admin/collections'
import Enum from '../pages_v2/admin/enum'
import NewCasesListPage from '../pages_v2/appeals/list'
import CardAppeal from '../pages_v2/appeals/card'
import Fields from '../pages_v2/admin/fields'
import FieldGroups from '../pages_v2/admin/field-groups'
import HrDashboard from '../pages/dashboard-hr'
import FeedbackFunnel from '../pages/feedback-funnel'
import HrPaymentsList from '../pages_v2/hr/payments/list'
import HrPaymentsCard from '../pages_v2/hr/payments/card'
import HrPlansList from '../pages_v2/hr/plans/list'
import EmployeeCard from '../pages_v2/employees/card'
import EmployeesListPage from '../pages/employees/list'
import EmployeeCardPage from '../pages/employees/card'
import MenuEditor from '../pages_v2/admin/menu_editor'
import LogisticDeliveryListPage from '../pages_v2/deliveries/list'
import LogisticRouteSheetsListPage from '../pages_v2/route-sheets/list'
import LogisticDeliveryCardPage from '../pages_v2/deliveries/card'
import MeasurementsList from '../pages_v2/mesurements/list'
import MeasurementsCardPage from '../pages_v2/mesurements/card'
import MontageList from '../pages_v2/montage/list'
import MontageCardPage from '../pages_v2/montage/card'
import { OrderStagePlanEditor } from '../pages_v2/admin/order-stage-plan'
import { ClaimStagePlanEditor } from '../pages_v2/admin/claim-stage-plan'
import { OrdersDashboardPage } from '../pages_v2/orders-dashboard'
import DocumentTemplates from '../pages_v2/document-templates'
import { PowerbiReport } from '../pages_v2/powerbi-report'
import ClaimsRequestsList from '../pages_v2/claims-request/list'
import ClaimRequest from '../pages_v2/claims-request/card'
import ClaimsList from '../pages_v2/claims/list'
import ClaimPage from '../pages_v2/claims/claim/index'
import ClaimsWorksList from '../pages_v2/claims-works/list'
import ClaimsWorksCard from '../pages_v2/claims-works/card'
import EmailMonitor from '../pages/email-monitor'
import { AIUiEmbed } from '../pages_v2/ai-reports'
import DocumentEditor from '../pages_v2/document-editor'
import TenantsListPage from '../pages_v2/dealers/list'
import TenantCardPage from '../pages_v2/dealers/card'
import PlatformModulesPage from '../pages_v2/dealers/modules/list'
import PlatformSettingsPage from '../pages_v2/dealers/settings'
import PlatformAdminRedirect from '../pages_v2/dealers/platform-admin-redirect'
import DealersControlPlaneGate from '../pages_v2/dealers/dealers-control-plane-gate'
import TenantRegistrationPage from '../pages_v2/dealers/tenant-registration'
import OnboardingPollPage from '../pages_v2/onboarding/poll'
import AdminPollPage from '../pages_v2/admin/poll'
import PollPreviewPage from '../pages_v2/admin/poll/preview'
import PollBindingsPage from '../pages_v2/admin/poll/bindings'
import OrdersImport from '../pages_v2/admin/orders_import'
import ModulesSettingsPage from '../pages_v2/settings/modules'
import BillingPage from '../pages_v2/billing'

/** Dual-run: when platform-admin host is baked in, ERP dealers routes redirect to base. */
const CONTROL_PLANE_EXTERNAL = Boolean(
  String(process.env.REACT_APP_PLATFORM_ADMIN_HOST || '').trim(),
)

const dealersList = CONTROL_PLANE_EXTERNAL ? (
  <PlatformAdminRedirect />
) : (
  <DealersControlPlaneGate Local={TenantsListPage} />
)
const dealersCard = CONTROL_PLANE_EXTERNAL ? (
  <PlatformAdminRedirect />
) : (
  <DealersControlPlaneGate Local={TenantCardPage} />
)
const dealersModules = CONTROL_PLANE_EXTERNAL ? (
  <PlatformAdminRedirect />
) : (
  <DealersControlPlaneGate Local={PlatformModulesPage} />
)
const dealersSettings = CONTROL_PLANE_EXTERNAL ? (
  <PlatformAdminRedirect />
) : (
  <DealersControlPlaneGate Local={PlatformSettingsPage} />
)
const dealersPolls = CONTROL_PLANE_EXTERNAL ? (
  <PlatformAdminRedirect />
) : (
  <DealersControlPlaneGate Local={AdminPollPage} />
)
const dealersPollPreview = CONTROL_PLANE_EXTERNAL ? (
  <PlatformAdminRedirect />
) : (
  <DealersControlPlaneGate Local={PollPreviewPage} />
)
const dealersPollBindings = CONTROL_PLANE_EXTERNAL ? (
  <PlatformAdminRedirect />
) : (
  <DealersControlPlaneGate Local={PollBindingsPage} />
)

export type RouteConfig = {
  path: string
  element: JSX.Element
  private?: boolean
  noLayout?: boolean
  /** Имена прав (`permissions_new`), как ключи в `sessionData.permissionsWithScope`. */
  allowedPermissions?: string[]
  /** Код модуля, который должен быть активен для доступа к роуту. */
  requiredModule?: string
}

export const routes: RouteConfig[] = [
  /* Неиспользуемые/устаревшие роуты

  { path: '/planning/tasks', element: <TasksListPage />, private: true }, // задачи
  { path: '/planning/tasks-orders', element: <TasksListOrderPage />, private: true }, // скорее всего задачи по заказам

  { path: '/sales/measurements', element: <FrozesListPage />, private: true }, // список замеров
  { path: '/froze/:id/edit', element: <FrozeCardPage />, private: true }, // карточка замера

  { path: '/employees', element: <EmployeeListPage />, private: true }, // список сотрудников
  { path: '/employees/:id', element: <CardEmployeePage />, private: true }, // карточка сотрудника

  { path: '/sales/mounting', element: <MountingListPage />, private: true }, // список монтажей
  { path: '/mounting/:id/edit', element: <CardMountingPage />, private: true }, // карточка монтажа

  { path: '/production-page', element: <ManufactureListPage />, private: true }, // список производства
  { path: '/manufacture/:id/edit', element: <CardManufacturePage />, private: true }, // заголовок - Заказ, судя по роуту и стадиям - производство

  { path: '/sales/orders', element: <OrdersListPage />, private: true }, // список заказов

  { path: '/call-center/cases', element: <CasesListPage />, private: true }, // список обращений
  { path: '/case/:id/edit', element: <EditCasePage />, private: true }, // карточка обращения

  { path: '/clients/:id', element: <CardClient />, private: true }, // карточка клиента

  { path: '/mails', element: <MailsListPage />, private: true }, // список емейлов
  { path: '/mails/:id', element: <CardMail />, private: true }, // просмотр емейла

  { path: '/delivery/:id/edit', element: <CardDeliveryPage />, private: true }, // карточка доставки
  { path: '/audit/:id/edit', element: <AuditCardPage />, private: true }, // карточка аудита

  { path: '/sales/complaint', element: <ComplaintListPage />, private: true }, // список рекламаций
  { path: '/complaint/:id/edit', element: <ComplaintCardPage />, private: true }, // карточка рекламации

  { path: '/users', element: <PageListUsers />, private: true }, // список пользователей
  { path: '/user/:id', element: <PageCardUser />, private: true }, // карточка пользователя

  { path: '/organizations', element: <PageListOrganizations />, private: true }, // список организаций
  { path: '/organizations/:id', element: <PageCardOrganization />, private: true }, // карточка организации

  { path: '/reports', element: <ReportsList />, private: true }, // отчеты
  { path: '/report/:id', element: <ReportCard />, private: true }, // страница отчета

  { path: '/profiles-organization', element: <PageListProfilesOrganizations />, private: true }, // список организаций/пользователей в организациях
  { path: '/profile-organization/:id', element: <PageCardProfileOrganization />, private: true }, // страница организации/пользователя

  { path: '/migration', element: <Migration />, private: true }, // ендпоинта нет

  { path: '/dadata-test', element: <DadataTest />, private: true },
  */
  // Используемые роуты
  { path: '/login', element: <LoginPage /> },
  { path: '/password-recovery', element: <PasswordRecoveryPage /> },
  { path: '/password-reset', element: <PasswordResetPage /> },
  { path: '/invite', element: <InviteAcceptPage /> },
  { path: '/register', element: <TenantRegistrationPage /> },
  { path: '/home', element: <HomePage />, private: true },
  // ПРОТОТИП единого раздела сотрудников (старые страницы не тронуты)
  {
    path: '/personnel',
    element: <PersonnelPage />,
    private: true,
    allowedPermissions: ['admin_organizations'],
  },
  { path: '/home/company-ui-lab', element: <CompanyUiLabPage />, private: true },
  { path: '/onboarding/poll', element: <OnboardingPollPage />, private: true, noLayout: true },
  { path: '/call-center/clients', element: <ListClients />, private: true },
  { path: '/logistic-delivery', element: <DeliveryListPage />, private: true },
  { path: '/call-center-telephony', element: <ListCallLog />, private: true },
  { path: '/report/marketing', element: <ReportMarketingCard />, private: true }, // Конверсии (не загружается, ошибка 500 от /api/order_report/enum)
  { path: '/report/marketing-list', element: <ReportMarketingList />, private: true }, // Похоже отчет по заказам
  { path: '/sales/audit', element: <AuditListPage />, private: true },
  { path: '/reports-satels/claims', element: <ClaimsListPage />, private: true },
  { path: '/claims/:id', element: <ClaimCardPage />, private: true },
  { path: '/claims/:id/edit', element: <ClaimCardPage />, private: true },
  { path: '/claim-requests', element: <ClaimRequestsListPage />, private: true },
  { path: '/claim-requests/:id', element: <ClaimRequestCardPage />, private: true },
  { path: '/claim-requests/:id/edit', element: <ClaimRequestCardPage />, private: true },
  { path: '/hr/payments', element: <HrPaymentsList />, private: true, requiredModule: 'hr' },
  { path: '/hr/payments/:id', element: <HrPaymentsCard />, private: true, requiredModule: 'hr' },
  { path: '/hr/plans', element: <HrPlansList />, private: true, requiredModule: 'hr' },
  { path: '/hr-employees', element: <EmployeesListPage />, private: true, requiredModule: 'hr' },
  { path: '/hr-employees/:id', element: <EmployeeCardPage />, private: true, requiredModule: 'hr' },
  { path: '/hr/dashboard', element: <HrDashboard />, private: true, requiredModule: 'hr' },
  { path: '/reports-sales-contracts', element: <OrdersDashboardPage />, private: true },
  { path: '/hr/feedback-funnel', element: <FeedbackFunnel />, private: true, requiredModule: 'hr' },
  { path: '/hr', element: <HrListPage />, private: true, requiredModule: 'hr' },
  { path: '/hr/:id', element: <HrCardPage />, private: true, requiredModule: 'hr' },
  {
    path: '/admin',
    element: <AdminCollectionsListPage />,
    private: true,
    allowedPermissions: [Permissions.ACCESS_ADMIN],
  },
  {
    path: '/admin/collections',
    element: <AdminCollectionsListPage />,
    private: true,
    allowedPermissions: [Permissions.ACCESS_ADMIN],
  },
  { path: '/admin/collections/new', element: <AdminNewCollectionPage />, private: true },
  { path: '/admin/collections/:id', element: <AdminEditCollectionPage />, private: true },
  { path: '/admin/collections/:name/objects', element: <AdminObjectsListPage />, private: true },
  { path: '/admin/collections/:name/objects/new', element: <AdminNewObjectPage />, private: true },
  {
    path: '/admin/collections/:name/objects/:id/:group/edit',
    element: <AdminEditObjectPage />,
    private: true,
  },
  { path: '/admin/schemas', element: <AdminSchemasListPage />, private: true },
  { path: '/admin/schemas/new', element: <AdminNewSchemaPage />, private: true },
  { path: '/admin/schemas/:id', element: <AdminEditSchemaPage />, private: true },
  { path: '/calculator', element: <CalculatorPage />, private: true },
  { path: '/admin/roles', element: <AdminListRoles />, private: true },
  { path: '/admin/role/:id', element: <AdminEditRole />, private: true },
  { path: '/appeals', element: <NewCasesListPage />, private: true },
  { path: '/appeal/:id', element: <CardAppeal />, private: true },
  { path: '/orders', element: <NewOrdersListPage />, private: true },
  { path: '/order/:id', element: <CardOrder />, private: true },
  { path: '/call-center/new-clients', element: <NewListClients />, private: true },
  { path: '/client-new/:id', element: <NewClientCardPage />, private: true },
  { path: '/admin/fields', element: <Fields />, private: true },
  {
    path: '/admin/field-groups',
    element: <FieldGroups />,
    private: true,
    allowedPermissions: [Permissions.ACCESS_ADMIN],
  },
  { path: '/tasks', element: <Tasks />, private: true },
  { path: '/tasks/calendar', element: <TasksCalendar />, private: true },
  { path: '/new/organizations', element: <OrganizationsList />, private: true },
  { path: '/new/organization/:id', element: <OrganizationCard />, private: true },
  { path: '/offices/:id', element: <OfficesList />, private: true },
  { path: '/office/:id', element: <OfficeCard />, private: true },
  { path: '/office/:organization_id/new', element: <OfficeCard />, private: true },
  // { path: '/users-new', element: <UsersListPage />, private: true },
  // { path: '/users-new/:id', element: <UserCardPage />, private: true },
  { path: '/admin/enum-collections', element: <Collections />, private: true },
  { path: '/admin/enum-collection/:id', element: <Enum />, private: true },
  { path: '/employees_new/:user_id', element: <EmployeeCard />, private: true },
  { path: '/admin/menu-editor', element: <MenuEditor />, private: true },
  {
    path: '/admin/orders_import',
    element: <OrdersImport />,
    private: true,
  },
  {
    path: '/logistics/deliveries',
    element: <LogisticDeliveryListPage />,
    private: true,
    requiredModule: 'logistics',
  },
  {
    path: '/logistics/route-sheets',
    element: <LogisticRouteSheetsListPage />,
    private: true,
    requiredModule: 'logistics',
  },
  {
    path: '/logistics/deliveries/:id',
    element: <LogisticDeliveryCardPage />,
    private: true,
    requiredModule: 'logistics',
  },
  {
    path: '/measurements',
    element: <MeasurementsList />,
    private: true,
    requiredModule: 'measurements',
  },
  {
    path: '/measurements/:id',
    element: <MeasurementsCardPage />,
    private: true,
    requiredModule: 'measurements',
  },
  { path: '/montage', element: <MontageList />, private: true, requiredModule: 'montage' },
  {
    path: '/montage/:id',
    element: <MontageCardPage />,
    private: true,
    requiredModule: 'montage',
  },
  { path: '/admin/order-stage-plan', element: <OrderStagePlanEditor />, private: true },
  { path: '/admin/claim-stage-plan', element: <ClaimStagePlanEditor />, private: true },
  {
    path: '/document-templates',
    element: <DocumentTemplates />,
    private: true,
    requiredModule: 'documents',
  },
  { path: '/powerbi-report', element: <PowerbiReport />, private: true },
  {
    path: '/claims-requests',
    element: <ClaimsRequestsList />,
    private: true,
    requiredModule: 'claims',
  },
  {
    path: '/claim-request/:id',
    element: <ClaimRequest />,
    private: true,
    requiredModule: 'claims',
  },
  { path: '/claims', element: <ClaimsList />, private: true, requiredModule: 'claims' },
  { path: '/claim/:id', element: <ClaimPage />, private: true, requiredModule: 'claims' },
  { path: '/claims-works', element: <ClaimsWorksList />, private: true, requiredModule: 'claims' },
  {
    path: '/claim-work/:id',
    element: <ClaimsWorksCard />,
    private: true,
    requiredModule: 'claims',
  },
  { path: '/admin/email-monitor', element: <EmailMonitor />, private: true },
  // «Отчёты ИИ» (MCP2 / SvetoforAI). Управление интеграциями дополнительно
  // ограничено администратором ERP на сервере (createMcpIntegrationAdminMiddleware).
  {
    path: '/ai/integrations/*',
    element: <AIUiEmbed />,
    private: true,
    requiredModule: 'ai-reports',
  },
  {
    path: '/ai/*',
    element: <AIUiEmbed />,
    private: true,
    requiredModule: 'ai-reports',
  },
  {
    path: '/admin/dealers/domains',
    element: dealersList,
    private: true,
    allowedPermissions: [Permissions.ACCESS_ADMIN],
  },
  {
    path: '/admin/dealers/domains/:tenantId',
    element: dealersCard,
    private: true,
    allowedPermissions: [Permissions.ACCESS_ADMIN],
  },
  {
    path: '/admin/dealers/modules',
    element: dealersModules,
    private: true,
    allowedPermissions: [Permissions.ACCESS_ADMIN],
  },
  {
    path: '/admin/dealers/settings',
    element: dealersSettings,
    private: true,
    allowedPermissions: [Permissions.ACCESS_ADMIN],
  },
  { path: '/settings/modules', element: <ModulesSettingsPage />, private: true },
  { path: '/billing', element: <BillingPage />, private: true },
  { path: '/settings/billing', element: <BillingPage />, private: true },
  { path: '/document_editor/:id', element: <DocumentEditor />, private: true },
  {
    path: '/admin/dealers/polls',
    element: dealersPolls,
    private: true,
    allowedPermissions: [Permissions.ACCESS_ADMIN],
  },
  {
    path: '/admin/dealers/polls/:quizId/preview',
    element: dealersPollPreview,
    private: true,
    allowedPermissions: [Permissions.ACCESS_ADMIN],
  },
  {
    path: '/admin/dealers/polls',
    element: dealersPolls,
    private: true,
    allowedPermissions: [Permissions.ACCESS_ADMIN],
  },
  {
    path: '/admin/dealers/polls/:quizId/preview',
    element: dealersPollPreview,
    private: true,
    allowedPermissions: [Permissions.ACCESS_ADMIN],
  },
  {
    path: '/admin/dealers/polls/:quizId/bindings',
    element: dealersPollBindings,
    private: true,
    allowedPermissions: [Permissions.ACCESS_ADMIN],
  },
]
